import { connect } from "react-redux";

const Confirm = (props) => {
   const {
      children,
      onClose,
      onConfirm,
      isShowButtonLoading = false,
      buttonLoading
   } = props;

   return (
      <div className="app-v2-popup-container popup-container is_opening" >
         {onClose && <div className="popup-overlay" onClick={onClose}></div>}
         <div className="popup-wrapper popup-confirm-wrapper">
            <div className="popup-content-wrapper">
               <div className="popup-btn-close" onClick={onClose}>
                  <svg viewBox="0 0 32 32">
                     <path d="M18.263 16l10.07-10.07c.625-.625.625-1.636 0-2.26s-1.638-.627-2.263 0L16 13.737 5.933 3.667c-.626-.624-1.637-.624-2.262 0s-.624 1.64 0 2.264L13.74 16 3.67 26.07c-.626.625-.626 1.636 0 2.26.312.313.722.47 1.13.47s.82-.157 1.132-.47l10.07-10.068 10.068 10.07c.312.31.722.468 1.13.468s.82-.157 1.132-.47c.626-.625.626-1.636 0-2.26L18.262 16z">
                     </path>
                  </svg>
               </div>
               <div className="popup-confirm-content">
                  {children}
               </div>
               <div className="app-v2-popup-footer">
                  {onClose && <button className="btn btn-default" onClick={onClose}>Huỷ</button>}
                  {onConfirm &&
                     <div>
                        {(isShowButtonLoading && buttonLoading)
                           ?
                           <div className="p-lg-l p-lg-r p-sm-l p-sm-r btn-icon-only-loading">
                              <div className="m-center">
                                 <div className="spinner-live-chat">
                                 </div>
                              </div>
                           </div>
                           :
                           <button className="btn btn-danger pull-right" onClick={onConfirm}>Xác nhận</button>
                        }
                     </div>
                  }
               </div>
            </div>
         </div>
      </div>
   )
}

const mapStateToProps = (state) => {
   const { buttonLoading } = state;
   return {
      buttonLoading
   };
}

export default connect(mapStateToProps, {})(Confirm);